import {useQuery} from 'react-query'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import { ChatViewForm } from './UserEditModalForm'

const UserEditModalFormWrapper = () => {
  return <ChatViewForm   isUserLoading={false} />
  return null
}

export {UserEditModalFormWrapper}
